import { AppShape, MessageShape } from "@eave/shared/types/api";

export interface IMapStateToProps {
  loading: boolean;
  appId: string;
  app: AppShape;
  editingHurdle: string;
}

export interface IMapDispatchToProps {
  createNewDisclosure: (id: string, stage: string, eSign: string) => void;
  loadApp: (id: string) => void;
  loadMessages: (id: string) => void;
  getUnreadMessageCount: (appId: string) => void;
  messageReceived: (appId: string, message: MessageShape) => void;
  commentReceived: (message: MessageShape) => void;
  navigate: (path: string) => void;
  setCurrentHurdleName: (hurdleName: string) => void;
  clearCurrentHurdleName: () => void;
}

export enum LoadingState {
  INACTIVE = "inactive",
  ACTIVE = "active",
  FINISHED = "finished",
}

export enum IncomeType {
  SelfEmployed = "selfEmployed",
  Salaried = "salaried",
  Other = "other",
}

export const incomeTypeToStr = (it: IncomeType) => {
  switch (it) {
    case IncomeType.SelfEmployed:
      return "Self-employed";
    case IncomeType.Salaried:
      return "Salaried";
    case IncomeType.Other:
      return "Other";
    default:
      return "INCOME TYPE NOT FOUND";
  }
};

export enum EmploymentType {
  FullTime = "fullTime",
  PartTime = "partTime",
}
